export const CALENDAR_SETTINGS_DRAG_DROP_KEY = 'calendar.dragDrop';
export const CALENDAR_SETTINGS_RANGE_KEY = 'calendar.mode';
